import React from 'react'
import { t } from '../../../i18n'

interface StarRatingProps {
  value: number
  onChange?: (value: number) => void
  size?: number
}

const STARS = [1, 2, 3, 4, 5]

const starClass = (filled: boolean) =>
  `star-rating__star${filled ? ' star-rating__star--filled' : ''}`

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  size = 18
}) => {
  const rounded = Math.round(value)
  const style = { fontSize: `${size}px` }

  if (!onChange) {
    return (
      <span
        role="img"
        aria-label={t('comments.rating_aria', { value: value.toFixed(1) })}
        className="star-rating"
      >
        {STARS.map((star) => (
          <span
            key={star}
            aria-hidden="true"
            className={starClass(star <= rounded)}
            style={style}
          >
            ★
          </span>
        ))}
      </span>
    )
  }

  return (
    <span
      role="radiogroup"
      aria-label={t('comments.rating')}
      className="star-rating"
    >
      {STARS.map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={star === rounded}
          aria-label={t('comments.rate_aria', { star })}
          className={`star-rating__button ${starClass(star <= rounded)}`}
          style={style}
          onClick={() => onChange(star)}
        >
          ★
        </button>
      ))}
    </span>
  )
}

export default StarRating
